import { ITrend } from '@sdk/contracts';
import styled from 'styled-components';

type Props = {
  trend?: ITrend;
};

export const StatWrapper = styled.div<Props>`
  display: flex;
  align-items: center;
  color: ${({ theme, trend }) =>
    trend === 'up'
      ? theme.colors.green7
      : trend === 'down'
      ? theme.colors.red7
      : theme.colors.black10};

  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
`;
